import _ from 'underscore';

export const isCardValid = ({ occupiedColNumber = 1 }) =>
  _.isNumber(occupiedColNumber) && occupiedColNumber > 0;

export const getMinOccupiedColNumber = validCards =>
  _.min(validCards, ({ occupiedColNumber = 1 }) => occupiedColNumber).occupiedColNumber || 1;
